@if (testEnvironment) {
    <aside class="environment-banner" [attr.aria-label]="'label_test_environment' | translate: { environment: testEnvironment }">
        <strong>{{ 'label_test_environment' | translate: { environment: testEnvironment } }}</strong>
        <span class="environment-banner__separator" aria-hidden="true">|</span>
        <span>{{ 'text_test_environment_warning' | translate }}</span>
    </aside>
}
<router-outlet></router-outlet>
<app-alert></app-alert>
@if (loader) {
    <app-loader-main [@fadeInOut]></app-loader-main>
}
